<template>
  <Teleport to="body">
    <!-- aria-live=polite: announced by screen readers without stealing focus -->
    <div class="toasts" role="status" aria-live="polite">
      <TransitionGroup name="toast">
        <div v-for="toast in toasts" :key="toast.id" class="toast" :class="`toast--${toast.level}`">
          <div class="grow">
            <p v-if="toast.title" class="toast__title">{{ toast.title }}</p>
            <p class="toast__message">{{ toast.message }}</p>
          </div>
          <UiClose size="sm" :label="uiLabel('dismiss')" @click="dismiss(toast.id)" />
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup>
import { useToast } from '../composables/useToast'
import { uiLabel } from '../utils/labels'
import UiClose from './UiClose.vue'

const { toasts, dismiss } = useToast()
</script>

<style scoped>
.toasts {
  position: fixed;
  /* Desde arriba de lo que se ve: cuando iOS desplaza la pantalla para enseñar
     la caja en que se escribe, un aviso a `top` fijo nacía fuera de ella. */
  top: calc(var(--viewport-top, 0px) + var(--space-4) + env(safe-area-inset-top, 0px));
  right: var(--space-4);
  z-index: 200;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  max-width: min(380px, calc(100vw - 2 * var(--space-4)));
}

.toast {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-left: 3px solid var(--color-text-mute);
  border-radius: var(--radius);
  box-shadow: var(--shadow-lg);
}

.toast--success { border-left-color: var(--color-success); }
.toast--warning { border-left-color: var(--color-warning); }
.toast--danger  { border-left-color: var(--color-danger); }
.toast--info    { border-left-color: var(--color-info); }

.toast__title { font-weight: 600; font-size: var(--text-sm); }
.toast__message { font-size: var(--text-sm); color: var(--color-text-soft); }


.toast-enter-active, .toast-leave-active { transition: all var(--base); }
.toast-enter-from { opacity: 0; transform: translateX(20px); }
.toast-leave-to   { opacity: 0; transform: translateX(20px); }
</style>
